import axios from 'axios'
// import { i18n } from '@/i18n'
export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchLogout(ctx) {
      return axios({
        method: 'POST',
        url: 'api/logout',
      }).then(() => {
        delete axios.defaults.headers.common.Authorization
        localStorage.removeItem('token')
        localStorage.removeItem('refresh')
        ctx.dispatch('clearSession')
        ctx.dispatch('SOCKET_CLOSE')
      })
    },
    auth(ctx, userData) {
      const fd = new FormData()
      for (let data in userData) {
        fd.append(data, userData[data])
      }

      return axios({
        method: 'POST',
        url: 'api/auth/login/model/',
        data: fd,
        headers: { Authorization: null },
      })
        .then(async (response) => {
          const result = response.data
          localStorage.setItem('token', result.token)
          localStorage.setItem('refresh', result.refresh)
          axios.defaults.headers.common.Authorization = `Bearer ${result.token}`
          await ctx.dispatch('fetchSession')
          return { status: true }
        })
        .catch((error) => {
          localStorage.removeItem('token')
          localStorage.removeItem('refresh')
          delete axios.defaults.headers.common.Authorization
          console.error(error)
          // ctx.dispatch('fetchAlerts', {
          //   alerts: i18n.t(`interface.errors.${error.response.data.code}`),
          //   type: 'error',
          // })
          return { status: false, code: error.response.data.code }
        })
    },
    authSso(ctx, userData) {
      const fd = new FormData()
      for (let data in userData) {
        fd.append(data, userData[data])
      }

      return axios({
        method: 'POST',
        url: 'api/auth/sso/',
        data: fd,
        headers: { Authorization: null },
      })
        .then(async (response) => {
          const result = response.data
          localStorage.setItem('token', result.token)
          localStorage.setItem('refresh', result.refresh)
          axios.defaults.headers.common.Authorization = `Bearer ${result.token}`
          await ctx.dispatch('fetchSession')
          return { status: true }
        })
        .catch((error) => {
          localStorage.removeItem('token')
          localStorage.removeItem('refresh')
          delete axios.defaults.headers.common.Authorization
          console.error(error)
          // ctx.dispatch('fetchAlerts', {
          //   alerts: i18n.t(`interface.errors.${error.response.data.code}`),
          //   type: 'error',
          // })
          return { status: false, code: error.response.data.code }
        })
    },
    addIDSocial(ctx, userData) {
      const fd = new FormData()
      fd.append('username', userData)

      return axios({
        method: 'POST',
        url: 'api/auth/join/free-id/',
        data: fd,
      })
        .then(async (response) => {
          const result = response.data
          localStorage.setItem('token', result.token)
          axios.defaults.headers.common.Authorization = `Bearer ${result.token}`
          await ctx.dispatch('fetchSession')
          return response.data
        })
        .catch((error) => {
          console.error(error)
          return error.response.status
        })
    },
    checkUser(ctx, { email }) {
      let endpoint = 'username'
      if (email.includes('@')) {
        endpoint = 'email'
      } else {
        endpoint = 'username'
      }
      return axios({
        method: 'GET',
        url: `api/auth/login/check-id/?${endpoint}=${email}`,
      })
        .then((response) => {
          if (response.status === 200) {
            return 200
          }
          return true
        })
        .catch((error) => {
          console.error(error)
          return false
        })
    },
    registration(ctx, { username, password, invite_code }) {
      const fd = new FormData()
      fd.append('username', username)
      fd.append('password', password)
      if (invite_code) {
        fd.append('invite_code', invite_code)
      }

      return axios({
        method: 'POST',
        url: 'api/auth/login/register/',
        data: fd,
      })
        .then((response) => {
          const result = response.data
          axios.defaults.headers.common.Authorization = `Bearer ${result.token}`
          localStorage.setItem('token', result.token)
          localStorage.setItem('refresh', result.refresh)
          ctx.commit('updateSession', result)
          return result
        })
        .catch((error) => {
          console.error(error)
          return error.response.data.password[0]
        })
    },
    tgLogin(ctx, userData) {
      const fd = new FormData()
      for (let data in userData) {
        fd.append(data, userData[data])
      }
      return axios({
        method: 'POST',
        url: 'api/auth/telegram/login/',
        data: fd,
        headers: {
          Authorization: null,
        },
      })
        .then((response) => {
          const result = response.data
          if (result.username) {
            axios.defaults.headers.common.Authorization = `Bearer ${result.token}`
            localStorage.setItem('token', result.token)
            localStorage.setItem('refresh', result.refresh)
            ctx.commit('updateSession', result)
            return true
          }
          return null
        })
        .catch((error) => {
          console.error(error)
          return false
        })
    },
    tgRegister(ctx, username) {
      const fd = new FormData()
      fd.append('username', username)
      return axios({
        method: 'POST',
        url: 'api/auth/telegram/register/',
        data: fd,
      })
        .then((response) => {
          console.log(response)
          const result = response.data
          ctx.commit('updateSession', result)
          return true
        })
        .catch((error) => {
          console.error(error)
          return error.response.status
        })
    },
    async restorePassword(ctx, userData) {
      const fd = new FormData()
      let endpoint = 'email'
      if (userData.includes('@')) {
        fd.append('email', userData)
      } else {
        endpoint = 'username'
        fd.append('username', userData)
      }

      return await axios({
        method: 'POST',
        url: `api/auth/password-recovery/${endpoint}/`,
        data: fd,
        headers: { Authorization: null },
      })
        .then(() => {
          return true
        })
        .catch((error) => {
          console.error(error)
          return error.response.data.code
        })
    },
  },
}
